import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["dsf_collapsed", "dsf_title", "dsf_collapsed_title", "dsf_collapse_text", "dsf_expand_text"]

import router, { DEFAULT_ROUTE } from '@/router'
import { DsfNavbar } from '@sennder/design-system-core'
import { analytics } from '@/services/analyticsProvider'
import AppNavigationItems from './AppNavigationItems.vue'

const LS_COLLAPSE_KEY = 'otters_navbar_collapse'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutSidebar',
  setup(__props) {

const onCollapse = () => {
  localStorage.setItem(LS_COLLAPSE_KEY, 'true')
}

const onExpand = () => {
  localStorage.removeItem(LS_COLLAPSE_KEY)
}

const collapsed = Boolean(localStorage.getItem(LS_COLLAPSE_KEY))

const navigate = (e: CustomEvent) => {
  const route = e.detail
  if (route) {
    router.push({ path: route })
    window.scrollTo(0, 0)
  }
}

function handleLogoClick() {
  analytics.trackShellEvent('click/icon-shipper-portal')
  router.push({ path: DEFAULT_ROUTE })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dsf-navbar", {
    dsf_collapsed: _unref(collapsed),
    dsf_title: _ctx.$t('navigation.title.expanded'),
    dsf_collapsed_title: _ctx.$t('navigation.title.collapsed'),
    dsf_collapse_text: _ctx.$t('navigation.item.collapse'),
    dsf_expand_text: _ctx.$t('navigation.expand'),
    onNavigate: navigate,
    onExpand: onExpand,
    onCollapse: onCollapse,
    onLogoClick: handleLogoClick
  }, [
    _createVNode(AppNavigationItems)
  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1))
}
}

})